import * as mutationTypes from 'store/mutationTypes'
import * as actions from './actions'

function getFilterCount(filters) {
  let totalFiltersApplied = 0

  Object.keys(filters).forEach((key) => {
    const value = filters[key]

    // console.log(`FILTER - ${key}`, value);

    if (key === 'cannabisTypes') {
      totalFiltersApplied += value.length || 0
    }

    if (key === 'discountValue' && value === true) {
      totalFiltersApplied += 1
    }

    if (key === 'search' && value !== null && value.length > 0) {
      totalFiltersApplied += 1
    }

    if (key === 'brand' && value !== null && value.length > 0) {
      totalFiltersApplied += 1
    }

    // console.log('totalFiltersApplied', totalFiltersApplied);
  })

  return totalFiltersApplied
}

export default {
  state: {
    filters: {
      cannabisTypes: [],
      discountValue: false,
      search: null,
      brand: null,
    },
    total: 0,
  },
  actions,
  mutations: {
    [mutationTypes.SET_CURRENT_ORDER_FILTERS](state, filters) {
      Object.assign(state.filters, filters || {})

      state.total = getFilterCount(state.filters)
    },
    [mutationTypes.REMOVE_CURRENT_ORDER_FILTERS](state) {
      Object.keys(state.filters).forEach((filter) => {
        if (filter === 'cannabisTypes') {
          state.filters.cannabisTypes = []
        }

        if (filter === 'discountValue' || filter === 'search' || filter === 'brand') {
          state.filters[filter] = null
        }
      })

      state.total = getFilterCount(state.filters)
    },
  },
}



// WEBPACK FOOTER //
// ./src/store/modules/orderFilters/index.js